import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ManufacturerPage.css';

function ManufacturerPage() {
  const { manufacturerId } = useParams();
  const [manufacturer, setManufacturer] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      
      // OPTIMIERT: Nur 2 Calls, Hersteller-Filter server-seitig über with-prices/all
      const [mfgRes, productsRes] = await Promise.all([
        fetch(`/api/manufacturers/${manufacturerId}`),
        fetch('/api/products/with-prices/all?onlineOnly=true')
      ]);
      const mfgData = await mfgRes.json();
      setManufacturer(mfgData);

      const allProducts = await productsRes.json();
      const manufacturerProducts = Array.isArray(allProducts) 
        ? allProducts.filter(p => p.manufacturerId === manufacturerId)
        : [];
      setProducts(manufacturerProducts);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [manufacturerId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <div className="manufacturer-page">
        <div className="loading">⏳ Lädt Daten...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manufacturer-page">
        <div className="error">Fehler: {error}</div>
      </div>
    );
  }

  if (!manufacturer) {
    return (
      <div className="manufacturer-page">
        <div className="error">Hersteller nicht gefunden</div>
      </div>
    );
  }

  return (
    <div className="manufacturer-page">
      <div className="manufacturer-header">
        <h1>🏭 {manufacturer.name}</h1>
        {manufacturer.description && <p>{manufacturer.description}</p>}
        {manufacturer.website && (
          <a href={manufacturer.website} target="_blank" rel="noopener noreferrer" className="website-link">
            Website besuchen →
          </a>
        )}
      </div>

      <div className="products-section">
        <h2>Produkte von {manufacturer.name}</h2>
        
        {products.length === 0 ? (
          <div className="no-products">
            <p>Keine Produkte für diesen Hersteller vorhanden.</p>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <Link 
                key={product._id} 
                to={`/product/${product._id}/suche`} 
                className="product-card-link"
              >
                <div className="product-card">
                  <div className="product-image-wrapper">
                    {product.productImage ? (
                      <img src={product.productImage} alt={product.name} className="product-card-image" />
                    ) : (
                      <div className="product-card-placeholder">Kein Bild</div>
                    )}
                  </div>
                  <div className="product-card-content">
                    <h3 className="product-card-name">{product.name}</h3>
                    <div className="product-card-specs">
                      {product.watts && (
                        <span className="spec-badge">⚡ {product.watts}W</span>
                      )}
                      {product.umolPerSecond && (
                        <span className="spec-badge">☀️ {product.umolPerSecond} mmol/s</span>
                      )}
                      {product.efficiency && (
                        <span className="spec-badge">💡 {product.efficiency} mmol/j</span>
                      )}
                      {product.growTentSize && (
                        <span className="spec-badge">🌱 {product.growTentSize}</span>
                      )}
                    </div>
                    {product.bestPrice !== null ? (
                      <div className="product-card-price">
                        <span className="price-label">ab</span>
                        <span className="price-value">€{product.bestPrice.toFixed(2)}</span>
                      </div>
                    ) : (
                      <div className="product-card-price">
                        <span className="price-label">Preis</span>
                        <span className="price-value">wird geladen...</span>
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ManufacturerPage;
